<template>
  <el-dialog :title="title" :visible.sync="open" width="600px" append-to-body>
    <el-form ref="form" :model="form" :rules="rules" label-width="100px">
      <el-row>
        <el-col :span="24">
          <el-form-item label="时间" prop="time">
            <el-date-picker v-model="form.time" value-format="yyyy-MM-dd HH:mm:ss" type="datetime" 
                            placeholder="选择时间" style="width: 100%;">
            </el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="状态" prop="status">
            <el-select v-model="form.status" placeholder="请选择状态" style="width: 100%;">
              <el-option label="计划中" value="planning"/>
              <el-option label="执行中" value="executing"/>
              <el-option label="已完成" value="completed"/>
              <el-option label="已暂停" value="paused"/>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="内容" prop="content">
            <el-input v-model="form.content" type="textarea" :rows="6" placeholder="请输入计划内容"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="submitForm" :loading="loading">确定</el-button>
      <el-button @click="cancel">取消</el-button>
    </div>
  </el-dialog>
</template>

<script>
import {querySafetyPlanDetail, addSafetyPlan, updateSafetyPlan} from "@/api/crm/safetyPlan";

export default {
  name: "SafetyPlanDialog",
  data() {
    return {
      // 弹出层标题
      title: "",
      // 是否显示弹出层
      open: false,
      // 是否为编辑模式
      isEdit: false,
      // 提交loading
      loading: false,
      // 表单参数
      form: {},
      // 表单校验
      rules: {
        time: [
          {required: true, message: "时间不能为空", trigger: "blur"}
        ],
        status: [
          {required: true, message: "状态不能为空", trigger: "change"}
        ],
        content: [
          {required: true, message: "内容不能为空", trigger: "blur"},
          {min: 1, max: 1000, message: "内容长度在1到1000个字符之间", trigger: "blur"}
        ]
      }
    };
  },
  methods: {
    // 打开对话框
    openDialog(id) {
      this.reset();
      this.open = true;
      
      if (id) {
        this.isEdit = true;
        this.title = "修改安全环保计划";
        this.getDetail(id);
      } else {
        this.isEdit = false;
        this.title = "新增安全环保计划";
      }
    },
    
    // 获取详情
    getDetail(id) {
      querySafetyPlanDetail({id}).then(response => {
        this.form = response.data;
      });
    },
    
    // 表单重置
    reset() {
      this.form = {
        id: null,
        time: null,
        content: null,
        status: null
      };
      this.resetForm("form");
    },
    
    // 取消按钮
    cancel() {
      this.open = false;
      this.reset();
    },
    
    // 表单提交
    submitForm() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          this.loading = true;
          
          const submitFn = this.isEdit ? updateSafetyPlan : addSafetyPlan;
          submitFn(this.form).then(() => {
            this.$message.success(this.isEdit ? "修改成功" : "新增成功");
            this.open = false;
            this.$emit("success");
          }).finally(() => {
            this.loading = false;
          });
        }
      });
    }
  }
};
</script>